(function () {
  var VISIBLE_THUMBS = 5;

  function formatMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) cents = 0;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var format =
        (window.MinimogSettings && window.MinimogSettings.money_format) ||
        (window.theme && window.theme.moneyFormat) ||
        '${{amount}}';
      return window.Shopify.formatMoney(cents, format);
    }
    return '$' + (cents / 100).toFixed(cents % 100 === 0 ? 0 : 2);
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function parseVariantData(root) {
    var el = root.querySelector('[data-bunky-variant-data]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function parseGalleryData(gallery) {
    var el = gallery.querySelector('[data-bunky-gallery-data]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function initGallery(gallery) {
    if (!gallery) return null;
    if (gallery.dataset.bunkyGalleryInit === 'true') {
      return gallery._bunkyGalleryApi || null;
    }
    gallery.dataset.bunkyGalleryInit = 'true';

    gallery.setAttribute('tabindex', '0');

    var data = parseGalleryData(gallery);
    if (!data || !data.media || !data.media.length) return null;

    var state = { index: data.initial_index || 0 };
    var viewport = gallery.querySelector('[data-bunky-thumbs-viewport]');
    var mainMedia = gallery.querySelector('[data-bunky-main-media]');
    var counter = gallery.querySelector('[data-bunky-gallery-counter]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-bunky-thumb]'));
    var thumbPrev = gallery.querySelector('[data-bunky-thumb-scroll="prev"]');
    var thumbNext = gallery.querySelector('[data-bunky-thumb-scroll="next"]');
    var thumbGap = 20;

    function renderMainMedia(item) {
      if (!mainMedia || !item) return;

      var existingBadge = mainMedia.querySelector('[data-bunky-sold-badge]');
      var badgeHidden = !existingBadge || existingBadge.classList.contains('is-hidden');
      var soldHtml =
        '<span class="bunky-pdp-sold-badge' +
        (badgeHidden ? ' is-hidden' : '') +
        '" data-bunky-sold-badge aria-live="polite" aria-hidden="' +
        (badgeHidden ? 'true' : 'false') +
        '">Sold!</span>';

      if (item.type === 'video' && item.sources && item.sources.length) {
        var sources = item.sources
          .map(function (s) {
            return '<source src="' + escapeHtml(s.url) + '" type="' + escapeHtml(s.mime) + '">';
          })
          .join('');
        mainMedia.innerHTML =
          soldHtml +
          '<video class="bunky-pdp-main-visual bunky-pdp-main-video" data-bunky-main-video controls playsinline preload="metadata" poster="' +
          escapeHtml(item.preview || item.src) +
          '">' +
          sources +
          '</video>';
        return;
      }

      if (item.type === 'external_video' && item.host && item.external_id) {
        var embed =
          item.host === 'youtube'
            ? 'https://www.youtube.com/embed/' + encodeURIComponent(item.external_id)
            : 'https://player.vimeo.com/video/' + encodeURIComponent(item.external_id);
        mainMedia.innerHTML =
          soldHtml +
          '<iframe class="bunky-pdp-main-visual bunky-pdp-main-external" src="' +
          embed +
          '" title="' +
          escapeHtml(item.alt || 'Product video') +
          '" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen loading="lazy"></iframe>';
        return;
      }

      mainMedia.innerHTML =
        soldHtml +
        '<img class="bunky-pdp-main-visual" id="mainVisual" data-bunky-main-img src="' +
        escapeHtml(item.src) +
        '" alt="' +
        escapeHtml(item.alt) +
        '">';
    }

    function isHorizontalViewport() {
      return true;
    }

    function applyVisibleThumbWindow() {
      if (!viewport || !thumbs.length) return;
      viewport.style.maxHeight = 'none';
      viewport.style.height = 'auto';
      viewport.style.width = '';
      viewport.style.maxWidth = '';
      updateThumbNavState();
    }

    function scrollThumbIntoView(index) {
      var thumb = thumbs[index];
      if (!thumb || !viewport) return;

      if (isHorizontalViewport()) {
        var left = thumb.offsetLeft;
        var right = left + thumb.offsetWidth;
        var viewLeft = viewport.scrollLeft;
        var viewRight = viewLeft + viewport.clientWidth;
        var pad = 8;

        if (left < viewLeft + pad) {
          viewport.scrollLeft = Math.max(0, left - pad);
        } else if (right > viewRight - pad) {
          viewport.scrollLeft = right - viewport.clientWidth + pad;
        }
      } else {
        var top = thumb.offsetTop;
        var bottom = top + thumb.offsetHeight;
        var viewTop = viewport.scrollTop;
        var viewBottom = viewTop + viewport.clientHeight;
        var padding = 8;

        if (top < viewTop + padding) {
          viewport.scrollTop = Math.max(0, top - padding);
        } else if (bottom > viewBottom - padding) {
          viewport.scrollTop = bottom - viewport.clientHeight + padding;
        }
      }

      updateThumbNavState();
    }

    function updateThumbNavState() {
      if (!viewport) return;
      var atStart;
      var atEnd;

      if (isHorizontalViewport()) {
        atStart = viewport.scrollLeft <= 2;
        atEnd = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2;
      } else {
        atStart = viewport.scrollTop <= 2;
        atEnd = viewport.scrollTop + viewport.clientHeight >= viewport.scrollHeight - 2;
      }

      if (thumbPrev) thumbPrev.disabled = atStart;
      if (thumbNext) thumbNext.disabled = atEnd;
    }

    function updateMainNavState() {
      var show = data.media.length > 1;
      gallery.querySelectorAll('[data-bunky-main-nav]').forEach(function (btn) {
        btn.classList.toggle('is-hidden', !show);
      });
      if (counter) counter.classList.toggle('is-hidden', !show);
    }

    function setActiveIndex(index, scrollThumb) {
      var len = data.media.length;
      if (!len) return;

      state.index = ((index % len) + len) % len;
      var item = data.media[state.index];

      thumbs.forEach(function (thumb, i) {
        var active = i === state.index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });

      renderMainMedia(item);

      if (counter) {
        counter.textContent = state.index + 1 + ' / ' + len;
      }

      if (scrollThumb !== false) {
        scrollThumbIntoView(state.index);
      }
    }

    function scrollThumbs(direction) {
      if (!viewport || thumbs.length <= VISIBLE_THUMBS) return;

      var viewStart;
      var viewEnd;

      if (isHorizontalViewport()) {
        viewStart = viewport.scrollLeft;
        viewEnd = viewStart + viewport.clientWidth;
      } else {
        viewStart = viewport.scrollTop;
        viewEnd = viewStart + viewport.clientHeight;
      }

      if (direction === 'next') {
        for (var i = 0; i < thumbs.length; i++) {
          var nextStart = isHorizontalViewport() ? thumbs[i].offsetLeft : thumbs[i].offsetTop;
          var nextEnd = nextStart + (isHorizontalViewport() ? thumbs[i].offsetWidth : thumbs[i].offsetHeight);
          if (nextEnd > viewEnd + 1) {
            scrollThumbIntoView(i);
            return;
          }
        }
      } else {
        for (var j = thumbs.length - 1; j >= 0; j--) {
          var prevStart = isHorizontalViewport() ? thumbs[j].offsetLeft : thumbs[j].offsetTop;
          if (prevStart < viewStart - 1) {
            scrollThumbIntoView(j);
            return;
          }
        }
      }

      updateThumbNavState();
    }

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setActiveIndex(parseInt(btn.dataset.index, 10), true);
      });
    });

    gallery.querySelectorAll('[data-bunky-main-nav]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var dir = btn.dataset.bunkyMainNav;
        setActiveIndex(state.index + (dir === 'next' ? 1 : -1), true);
      });
    });

    if (thumbPrev) {
      thumbPrev.addEventListener('click', function () {
        scrollThumbs('prev');
      });
    }

    if (thumbNext) {
      thumbNext.addEventListener('click', function () {
        scrollThumbs('next');
      });
    }

    if (viewport) {
      viewport.addEventListener('scroll', updateThumbNavState, { passive: true });
    }

    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        setActiveIndex(state.index - 1, true);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        setActiveIndex(state.index + 1, true);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        scrollThumbs('prev');
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        scrollThumbs('next');
      }
    });

    var needsThumbNav = data.media.length > VISIBLE_THUMBS;
    if (thumbPrev) thumbPrev.classList.toggle('is-hidden', !needsThumbNav);
    if (thumbNext) thumbNext.classList.toggle('is-hidden', !needsThumbNav);

    function refreshLayout() {
      applyVisibleThumbWindow();
      scrollThumbIntoView(state.index);
    }

    if (typeof ResizeObserver !== 'undefined' && viewport) {
      var resizeObserver = new ResizeObserver(refreshLayout);
      resizeObserver.observe(viewport);
      thumbs.forEach(function (thumb) {
        resizeObserver.observe(thumb);
      });
    }

    window.addEventListener('resize', refreshLayout);

    if (document.readyState === 'complete') {
      refreshLayout();
    } else {
      window.addEventListener('load', refreshLayout);
    }

    updateMainNavState();
    setActiveIndex(state.index, false);
    refreshLayout();

    var api = {
      goToMediaId: function (mediaId) {
        var idx = data.media.findIndex(function (m) {
          return String(m.id) === String(mediaId);
        });
        if (idx >= 0) setActiveIndex(idx, true);
      },
      goToIndex: function (idx) {
        setActiveIndex(idx, true);
      }
    };

    gallery._bunkyGalleryApi = api;
    return api;
  }

  function getSelectedOptions(root, data) {
    var options = { option1: null, option2: null, option3: null };
    var flavorPos = data.options.flavor_position;
    var packPos = data.options.pack_position;

    var activeFlavor = root.querySelector('[data-bunky-flavor].active:not([data-multi])');
    if (activeFlavor && flavorPos) {
      options['option' + flavorPos] = activeFlavor.dataset.optionValue;
    }

    var activeBundle = root.querySelector('[data-bunky-bundle].active');
    if (activeBundle && packPos && activeBundle.dataset.optionValue) {
      options['option' + packPos] = activeBundle.dataset.optionValue;
    }

    return options;
  }

  function findVariant(data, options) {
    return data.variants.find(function (v) {
      for (var i = 1; i <= 3; i++) {
        var key = 'option' + i;
        if (options[key] && v[key] && options[key] !== v[key]) return false;
      }
      return true;
    });
  }

  function initPdp(root) {
    if (!root || root.dataset.bunkyInit === 'true') return;
    root.dataset.bunkyInit = 'true';

    var galleryEl = root.querySelector('[data-bunky-gallery]');
    var galleryApi = galleryEl
      ? galleryEl._bunkyGalleryApi || initGallery(galleryEl)
      : null;

    var data = parseVariantData(root);
    if (!data) return;

    var variantInput = root.querySelector('[data-bunky-variant-input]');
    var sellingPlanInput = root.querySelector('[data-bunky-selling-plan-input]');
    var mainPrice = root.querySelector('[data-bunky-price]');
    var compareEl = root.querySelector('[data-bunky-compare]');
    var saveEl = root.querySelector('[data-bunky-save]');
    var onePrice = root.querySelector('[data-bunky-one-price]');
    var subPrice = root.querySelector('[data-bunky-sub-price]');
    var subCompare = root.querySelector('[data-bunky-sub-compare]');
    var subSavePct = root.querySelector('[data-bunky-sub-save-pct]');
    var subSaveAmount = root.querySelector('[data-bunky-sub-save-amount]');
    var subPlanBtn = root.querySelector('[data-bunky-subscribe-plan]');
    var subTitle = root.querySelector('[data-bunky-sub-title]');
    var planSelect = root.querySelector('[data-bunky-selling-plan-select]');
    var ctaBtn = root.querySelector('[data-bunky-cta]');
    var ctaPrefix = ctaBtn ? ctaBtn.dataset.ctaPrefix || 'Add to Cart' : 'Add to Cart';
    var soldBadge = root.querySelector('[data-bunky-sold-badge]');

    var activePlanEl = root.querySelector('[data-bunky-plan].active');
    var state = {
      plan: activePlanEl ? activePlanEl.dataset.plan || 'one' : 'one',
      variant: null,
      sellingPlanId: null,
      sellingPlanKey: null
    };

    function planFrequencyKey(plan) {
      if (!plan) return '';
      var opts = plan.options || [];
      for (var i = 0; i < opts.length; i++) {
        var n = String(opts[i].name || '').toLowerCase();
        if (
          n.indexOf('deliver') >= 0 ||
          n.indexOf('frequency') >= 0 ||
          n.indexOf('every') >= 0 ||
          n.indexOf('order') >= 0
        ) {
          return String(opts[i].value || '').toLowerCase();
        }
      }
      var m = String(plan.name || '').match(/(\d+)\s*day/i);
      if (m) return m[1] + ' days';
      return String(plan.name || '').toLowerCase();
    }

    function planFrequencyLabel(plan) {
      if (!plan) return '';
      var opts = plan.options || [];
      for (var i = 0; i < opts.length; i++) {
        var n = String(opts[i].name || '').toLowerCase();
        if (
          n.indexOf('deliver') >= 0 ||
          n.indexOf('frequency') >= 0 ||
          n.indexOf('every') >= 0 ||
          n.indexOf('order') >= 0
        ) {
          return opts[i].value || plan.name;
        }
      }
      return plan.name || 'Subscription';
    }

    function findSelectedPlan(plans) {
      if (!plans || !plans.length) return null;
      if (state.sellingPlanId) {
        var byId = plans.find(function (p) {
          return String(p.id) === String(state.sellingPlanId);
        });
        if (byId) return byId;
      }
      if (state.sellingPlanKey) {
        var byKey = plans.find(function (p) {
          return planFrequencyKey(p) === state.sellingPlanKey;
        });
        if (byKey) return byKey;
      }
      return plans[0];
    }

    function calcSave(variant, plan) {
      var oneTime = variant.price;
      var sub = plan.price;
      var compare = plan.compare_at_price > plan.price ? plan.compare_at_price : oneTime;
      var amount = Math.max(0, compare - sub);
      var pct = 0;
      if (compare > 0 && amount > 0) {
        pct = Math.round((amount / compare) * 100);
      }
      if (pct <= 0 && oneTime > sub) {
        amount = oneTime - sub;
        pct = Math.round((amount / oneTime) * 100);
        compare = oneTime;
      }
      return { amount: amount, pct: pct, compare: compare, sub: sub };
    }

    function updateCompare(variant) {
      if (!variant) return;
      var hasCompare = variant.compare_at_price > variant.price;
      if (compareEl) {
        compareEl.textContent = hasCompare ? formatMoney(variant.compare_at_price) : '';
        compareEl.classList.toggle('is-hidden', !hasCompare);
      }
      if (saveEl) {
        if (hasCompare) {
          var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          saveEl.textContent = 'SAVE ' + pct + '%';
        }
        saveEl.classList.toggle('is-hidden', !hasCompare);
      }
    }

    function setPurchasePlan(planType, opts) {
      opts = opts || {};
      state.plan = planType === 'sub' ? 'sub' : 'one';
      root.querySelectorAll('[data-bunky-plan]').forEach(function (el) {
        var isActive = el.dataset.plan === state.plan;
        el.classList.toggle('active', isActive);
        el.setAttribute('aria-checked', isActive ? 'true' : 'false');
        el.tabIndex = isActive ? 0 : -1;
      });
      if (!opts.skipSync) syncUI();
    }

    function updateSubscriptionUI(variant) {
      if (!variant || !subPlanBtn) return;
      var plans = variant.selling_plans || [];
      if (plans.length === 0) {
        // Preview mode: keep the Subscribe & Save card visible for design sign-off
        // even without a live selling plan (add-to-cart falls back to one-time).
        if (subPlanBtn.hasAttribute('data-bunky-sub-preview')) {
          subPlanBtn.classList.remove('is-hidden');
          if (subPrice) subPrice.textContent = formatMoney(variant.price);
          state.sellingPlanId = null;
          state.sellingPlanKey = null;
          return;
        }
        subPlanBtn.classList.add('is-hidden');
        if (state.plan === 'sub') setPurchasePlan('one', { skipSync: true });
        state.sellingPlanId = null;
        state.sellingPlanKey = null;
        return;
      }

      subPlanBtn.classList.remove('is-hidden');
      var plan = findSelectedPlan(plans);
      state.sellingPlanId = plan.id;
      state.sellingPlanKey = planFrequencyKey(plan);

      if (planSelect) {
        var prev = planSelect.value;
        planSelect.innerHTML = '';
        plans.forEach(function (p) {
          var opt = document.createElement('option');
          opt.value = String(p.id);
          opt.textContent = planFrequencyLabel(p);
          planSelect.appendChild(opt);
        });
        var keep = plans.find(function (p) {
          return String(p.id) === String(state.sellingPlanId);
        });
        planSelect.value = keep ? String(keep.id) : String(plans[0].id);
        if (!keep && prev) {
          var prevMatch = plans.find(function (p) {
            return String(p.id) === String(prev);
          });
          if (prevMatch) planSelect.value = String(prevMatch.id);
        }
        plan = findSelectedPlan(plans) || plan;
        state.sellingPlanId = plan.id;
        state.sellingPlanKey = planFrequencyKey(plan);
        planSelect.value = String(plan.id);
      }

      var savings = calcSave(variant, plan);
      if (subPrice) subPrice.textContent = formatMoney(savings.sub);
      if (subCompare) {
        subCompare.textContent = formatMoney(savings.compare);
        subCompare.classList.toggle('is-hidden', !(savings.compare > savings.sub));
      }
      if (subSavePct) {
        subSavePct.textContent = 'Save ' + savings.pct + '%';
        subSavePct.classList.toggle('is-hidden', savings.pct <= 0);
      }
      if (subSaveAmount) {
        subSaveAmount.textContent =
          savings.amount > 0
            ? 'Save ' + formatMoney(savings.amount) + ' on every order'
            : 'Save on every order';
      }
      if (subTitle) subTitle.textContent = 'Subscribe & Save';
    }

    function syncUI() {
      if (!state.variant) return;
      var v = state.variant;
      if (variantInput) variantInput.value = v.id;
      if (mainPrice) mainPrice.textContent = formatMoney(v.price);
      if (onePrice) onePrice.textContent = formatMoney(v.price);
      updateCompare(v);
      updateSubscriptionUI(v);
      updateVariantMeta(v);
      updatePackSelection(v);

      var selectedPlan = null;
      if (state.plan === 'sub' && v.selling_plans && v.selling_plans.length) {
        selectedPlan = findSelectedPlan(v.selling_plans);
        if (selectedPlan) {
          state.sellingPlanId = selectedPlan.id;
          state.sellingPlanKey = planFrequencyKey(selectedPlan);
        }
      }

      if (sellingPlanInput) {
        if (state.plan === 'sub' && state.sellingPlanId) {
          sellingPlanInput.value = state.sellingPlanId;
          sellingPlanInput.disabled = false;
        } else {
          sellingPlanInput.value = '';
          sellingPlanInput.disabled = true;
        }
      }

      var displayPrice = v.price;
      if (state.plan === 'sub' && selectedPlan) {
        displayPrice = selectedPlan.price;
      }
      if (ctaBtn) {
        ctaBtn.innerHTML = ctaPrefix + ' &nbsp;•&nbsp; ' + formatMoney(displayPrice);
        ctaBtn.disabled = !v.available;
      }
      var liveSoldBadge = root.querySelector('[data-bunky-sold-badge]');
      if (liveSoldBadge) {
        liveSoldBadge.classList.toggle('is-hidden', !!v.available);
        liveSoldBadge.setAttribute('aria-hidden', v.available ? 'true' : 'false');
      }
      syncStickyAtc(v, displayPrice, ctaPrefix);
      syncFinalCta(v, displayPrice);
    }

    function updateVariantMeta(variant) {
      var meta = root.querySelector('[data-bunky-variant-meta]');
      var skuEl = root.querySelector('[data-bunky-sku]');
      var invEl = root.querySelector('[data-bunky-inventory]');
      if (!meta) return;

      var bits = [];
      if (skuEl) {
        if (variant.sku) {
          skuEl.textContent = 'SKU: ' + variant.sku;
          bits.push('sku');
        } else {
          skuEl.textContent = '';
        }
      }
      if (invEl) {
        var invText = '';
        // Only mark sold out from Shopify availability — never from inventory_quantity alone
        // (storefront inventory counts are often 0 even when the variant is still for sale).
        if (!variant.available) {
          invText = 'Sold out';
        } else if (
          variant.inventory_management &&
          typeof variant.inventory_quantity === 'number' &&
          variant.inventory_quantity > 0 &&
          variant.inventory_quantity <= 10
        ) {
          invText = 'Only ' + variant.inventory_quantity + ' left';
        }
        invEl.textContent = invText;
        if (invText) bits.push('inv');
      }
      meta.classList.toggle('is-hidden', bits.length === 0);
    }

    function updatePackSelection(variant) {
      var currentLabel = '';
      var data = parseVariantData(root);
      var variants = (data && data.variants) || [];

      root.querySelectorAll('[data-bunky-bundle]').forEach(function (btn) {
        var isActive =
          (btn.dataset.variantId && String(btn.dataset.variantId) === String(variant.id)) ||
          (btn.dataset.optionValue &&
            (variant.option1 === btn.dataset.optionValue ||
              variant.option2 === btn.dataset.optionValue ||
              variant.option3 === btn.dataset.optionValue));
        btn.classList.toggle('active', !!isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');

        var btnVariant = null;
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(btn.dataset.variantId)) {
            btnVariant = variants[i];
            break;
          }
        }
        var soldOut = btnVariant ? !btnVariant.available : btn.dataset.available === 'false';
        btn.dataset.available = soldOut ? 'false' : 'true';
        btn.classList.toggle('is-sold-out', !!soldOut);
        btn.disabled = !!soldOut;
        btn.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
        // Never show "Sold out" text under pack cards — disable only.
        var statusEl = btn.querySelector('.bunky-pack-card__status');
        if (statusEl) statusEl.remove();

        if (isActive) {
          currentLabel = btn.dataset.packLabel || '';
          if (!currentLabel) {
            var labelEl = btn.querySelector('.bunky-pack-card__label');
            currentLabel = labelEl ? labelEl.textContent.trim() : '';
          }
        }
      });
      if (!currentLabel && variant.title) {
        var t = String(variant.title).toLowerCase();
        if (t.indexOf('12') >= 0) currentLabel = '12-Pack';
        else if (t.indexOf('6') >= 0) currentLabel = '6-Pack';
        else if (t.indexOf('4') >= 0) currentLabel = '4-Pack';
        else currentLabel = variant.title;
      }
      var packCurrent = root.querySelector('[data-bunky-pack-current]');
      if (packCurrent && currentLabel) packCurrent.textContent = currentLabel;
    }

    function initQuantity() {
      var qtyInput = root.querySelector('[data-bunky-qty-input]');
      if (!qtyInput || qtyInput.dataset.bunkyQtyInit === 'true') return;
      qtyInput.dataset.bunkyQtyInit = 'true';

      function clampQty() {
        var val = parseInt(qtyInput.value, 10);
        if (isNaN(val) || val < 1) val = 1;
        qtyInput.value = String(val);
      }

      qtyInput.addEventListener('change', clampQty);
      qtyInput.addEventListener('blur', clampQty);

      root.querySelectorAll('[data-bunky-qty-change]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var delta = parseInt(btn.dataset.bunkyQtyChange, 10) || 0;
          var val = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = String(Math.max(1, val + delta));
        });
      });
    }

    function syncStickyAtc(variant, displayPrice, prefix) {
      var sticky = document.querySelector('[data-bunky-sticky-atc]');
      if (!sticky) return;
      var stickyPrice = sticky.querySelector('[data-bunky-sticky-price]');
      var stickyCta = sticky.querySelector('[data-bunky-sticky-cta]');
      var stickyPack = sticky.querySelector('[data-bunky-sticky-pack]');
      if (stickyPrice) stickyPrice.textContent = formatMoney(displayPrice);
      if (stickyCta) {
        stickyCta.textContent = prefix || 'Add to Cart';
        stickyCta.disabled = !variant.available;
      }
      if (stickyPack) {
        var activePackBtn = root.querySelector('[data-bunky-bundle].active');
        var packText = activePackBtn && activePackBtn.dataset.packLabel
          ? activePackBtn.dataset.packLabel
          : '';
        if (!packText && activePackBtn) {
          var activePack = activePackBtn.querySelector('.bunky-pack-card__label');
          packText = activePack ? activePack.textContent.trim() : '';
        }
        if (!packText && variant.title) {
          var t = String(variant.title).toLowerCase();
          if (t.indexOf('12') >= 0) packText = '12-Pack';
          else if (t.indexOf('6') >= 0) packText = '6-Pack';
          else if (t.indexOf('4') >= 0) packText = '4-Pack';
          else packText = variant.title;
        }
        stickyPack.textContent = packText;
      }
    }

    function syncFinalCta(variant, displayPrice) {
      document.querySelectorAll('[data-bunky-final-cta]').forEach(function (cta) {
        var priceEl = cta.querySelector('[data-bunky-final-cta-price]');
        var packEl = cta.querySelector('[data-bunky-final-cta-pack]');
        var variantInput = cta.querySelector('[data-bunky-final-variant-input]');
        var button = cta.querySelector('[data-bunky-final-cta-button]');
        if (priceEl) priceEl.textContent = formatMoney(displayPrice);
        if (packEl) {
          var packText = '';
          var activePackBtn = root.querySelector('[data-bunky-bundle].active');
          if (activePackBtn && activePackBtn.dataset.packLabel) {
            packText = activePackBtn.dataset.packLabel;
          } else if (variant && variant.title) {
            var t = String(variant.title).toLowerCase();
            if (t.indexOf('12') >= 0) packText = '12-Pack';
            else if (t.indexOf('6') >= 0) packText = '6-Pack';
            else if (t.indexOf('4') >= 0) packText = '4-Pack';
            else packText = variant.title;
          }
          if (packText) packEl.textContent = packText;
        }
        if (variantInput) variantInput.value = variant.id;
        if (button && button.tagName === 'BUTTON') {
          button.disabled = !variant.available;
        }
      });
    }

    function setStickyPageOffset(sticky, visible) {
      var clearance = sticky ? sticky.offsetHeight + 24 : 0;
      document.documentElement.style.setProperty(
        '--bunky-sticky-offset',
        visible ? clearance + 'px' : '0px'
      );
      document.body.classList.toggle('bunky-has-sticky-atc', !!visible);
    }

    function initStickyAtc() {
      var sticky = document.querySelector('[data-bunky-sticky-atc]');
      if (!sticky || sticky.dataset.bunkyStickyInit === 'true') return;
      sticky.dataset.bunkyStickyInit = 'true';
      sticky.hidden = false;

      var stickyCta = sticky.querySelector('[data-bunky-sticky-cta]');
      var form = root.querySelector('form.bunky-pdp-form');
      var triggerEl = ctaBtn || form;

      function updateStickyVisibility() {
        var visible = true;
        if (triggerEl) {
          var rect = triggerEl.getBoundingClientRect();
          visible = rect.bottom < 0;
        }
        sticky.classList.toggle('is-visible', visible);
        setStickyPageOffset(sticky, visible);
      }

      window.addEventListener('scroll', updateStickyVisibility, { passive: true });
      window.addEventListener('resize', updateStickyVisibility);
      updateStickyVisibility();

      if (stickyCta && form) {
        stickyCta.addEventListener('click', function () {
          if (stickyCta.disabled) return;
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        });
      }
    }

    function notifyVariantChange() {
      if (!variantInput) return;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('variant:change', { bubbles: true }));
    }

    function applyVariant(variant) {
      if (!variant) return;
      state.variant = variant;
      syncUI();
      notifyVariantChange();

      if (variant.featured_media_id && galleryApi) {
        galleryApi.goToMediaId(variant.featured_media_id);
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    function resolveVariant() {
      var activeBundle = root.querySelector('[data-bunky-bundle].active:not(.is-unavailable)');
      if (!activeBundle) {
        activeBundle =
          root.querySelector('[data-bunky-bundle]:not(.is-unavailable)') ||
          root.querySelector('[data-bunky-bundle]');
        if (activeBundle) {
          root.querySelectorAll('[data-bunky-bundle]').forEach(function (x) {
            x.classList.remove('active');
          });
          activeBundle.classList.add('active');
        }
      }

      var directId = activeBundle ? activeBundle.dataset.variantId : null;
      if (directId) {
        var direct = data.variants.find(function (v) {
          return String(v.id) === String(directId);
        });
        if (direct) {
          applyVariant(direct);
          return;
        }
      }

      if (!root.querySelector('[data-bunky-flavor].active:not([data-multi])')) {
        var firstFlavor = root.querySelector('[data-bunky-flavor]:not([data-multi])');
        if (firstFlavor) firstFlavor.classList.add('active');
      }

      var selected = getSelectedOptions(root, data);
      var variant = findVariant(data, selected);
      if (!variant) {
        variant =
          data.variants.find(function (item) {
            return item.available;
          }) || data.variants[0];
      }
      applyVariant(variant);
    }

    root.querySelectorAll('[data-bunky-flavor]:not([data-multi])').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-bunky-flavor]:not([data-multi])').forEach(function (x) {
          x.classList.remove('active');
        });
        btn.classList.add('active');
        resolveVariant();
      });
    });

    root.querySelectorAll('[data-bunky-bundle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.dataset.productUrl) {
          window.location.href = btn.dataset.productUrl;
          return;
        }
        if (btn.classList.contains('is-unavailable') || btn.classList.contains('is-sold-out') || btn.disabled) {
          return;
        }
        root.querySelectorAll('[data-bunky-bundle]').forEach(function (x) {
          x.classList.remove('active');
          x.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('active');
        btn.setAttribute('aria-pressed', 'true');
        if (btn.dataset.variantId) {
          var v = data.variants.find(function (item) {
            return String(item.id) === String(btn.dataset.variantId);
          });
          if (v) applyVariant(v);
        } else {
          resolveVariant();
        }
      });
    });

    root.querySelectorAll('[data-bunky-plan]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        if (btn.classList.contains('is-hidden')) return;
        if (event.target && event.target.closest('[data-bunky-selling-plan-select]')) return;
        setPurchasePlan(btn.dataset.plan || 'one');
      });

      btn.addEventListener('keydown', function (event) {
        if (btn.classList.contains('is-hidden')) return;
        var plans = Array.prototype.slice.call(
          root.querySelectorAll('[data-bunky-plan]:not(.is-hidden)')
        );
        var idx = plans.indexOf(btn);
        if (event.key === ' ' || event.key === 'Enter') {
          event.preventDefault();
          setPurchasePlan(btn.dataset.plan || 'one');
          return;
        }
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
          event.preventDefault();
          var next = plans[(idx + 1) % plans.length];
          if (next) {
            setPurchasePlan(next.dataset.plan || 'one');
            next.focus();
          }
        }
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
          event.preventDefault();
          var prev = plans[(idx - 1 + plans.length) % plans.length];
          if (prev) {
            setPurchasePlan(prev.dataset.plan || 'one');
            prev.focus();
          }
        }
      });
    });

    if (planSelect) {
      planSelect.addEventListener('click', function (event) {
        event.stopPropagation();
      });
      planSelect.addEventListener('mousedown', function (event) {
        event.stopPropagation();
      });
      planSelect.addEventListener('change', function () {
        var plans = (state.variant && state.variant.selling_plans) || [];
        var chosen = plans.find(function (p) {
          return String(p.id) === String(planSelect.value);
        });
        if (chosen) {
          state.sellingPlanId = chosen.id;
          state.sellingPlanKey = planFrequencyKey(chosen);
        } else {
          state.sellingPlanId = planSelect.value;
          state.sellingPlanKey = null;
        }
        setPurchasePlan('sub');
      });
    }

    var params = new URLSearchParams(window.location.search);
    var paramVariant = params.get('variant');
    if (paramVariant) {
      var fromUrl = data.variants.find(function (v) {
        return String(v.id) === paramVariant;
      });
      if (fromUrl) state.variant = fromUrl;
    }
    if (!state.variant) resolveVariant();
    else {
      syncUI();
      if (state.variant.featured_media_id && galleryApi) {
        galleryApi.goToMediaId(state.variant.featured_media_id);
      }
    }

    initQuantity();
    initStickyAtc();
  }

  function boot() {
    document.querySelectorAll('[data-bunky-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-bunky-pdp]').forEach(initPdp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
